export function isAuthRoute(pathname: string): boolean {
  if (!pathname) return false;
  if (pathname === '/login') return true;
  if (pathname === '/signup') return true;
  if (pathname === '/auth') return true;
  if (pathname === '/auth/callback') return true;
  if (pathname.startsWith('/auth/')) return true;
  return false;
}
